import {
  IsString,
  MinLength,
  MaxLength,
  IsOptional,
  IsArray,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { AuthCredentialsInterface } from '../interfaces/auth-credentials.interface';

export class AuthCredentialsDto implements AuthCredentialsInterface {
  @ApiProperty({
    title: 'Username (or Email)',
    description: "The user's username (or email address).",
  })
  @IsString()
  @MinLength(4)
  @MaxLength(100)
  username!: string;

  @ApiProperty({ title: 'Password', description: "The user's password" })
  @IsString()
  @MinLength(8)
  @MaxLength(100)
  password!: string;

  @ApiPropertyOptional({
    title: 'Assert Roles',
    description:
      'Optionally provide an array of role(s) the user is expected to have in order to authenticate. ' +
      'This, of course, does not grant additional access, and is provided only as a convenience.',
  })
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  @MaxLength(100, { each: true })
  assertRoles!: string[];
}
